import React, { useState } from 'react';
import Icon from 'atomic/icon';
import NewsletterForm from 'components/newsletter/newsletter-form';
import Container from 'atomic/container';
import { newsletterData } from 'components/newsletter/newsletter.data';
import { setCookie } from 'helpers/cookie';

import './newsletter.scss';

interface NewsletterProps {
    isMobile: boolean;
    onNewsletterSubmit?: () => void;
}

const Newsletter: React.FC<NewsletterProps> = ({ isMobile, onNewsletterSubmit }) => {
    const [isNewsletterFormSubmitted, setIsNewsletterFormSubmitted] = useState(false);

    const onNewsletterFormSubmit = (): void => {
        setIsNewsletterFormSubmitted(true);
        setCookie('skp_newsletter', 'closed', { expiresDays: 1000, path: '/' });

        if (onNewsletterSubmit) {
            onNewsletterSubmit();
        }
    };

    return (
        <section className="newsletter">
            <div className="newsletter__circle" />
            <div className="newsletter__ellipce" />
            <div className="newsletter__moon" />
            <Container className="newsletter__container">
                <div className="newsletter__wrapper">
                    <h2 className="newsletter__header">
                        {newsletterData.header}
                    </h2>
                    <p className="newsletter__title">
                        {newsletterData.title}
                    </p>
                    <ul className="newsletter__list">
                        {newsletterData.list.map(item => (
                            <li
                                key={item}
                                className="newsletter__item"
                            >
                                <Icon
                                    name="check"
                                    size={16}
                                    color="primary"
                                />
                                <p>{item}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="newsletter__form-wrapper">
                    <div className="newsletter__form">
                        <NewsletterForm
                            isMobile={isMobile}
                            onFormSubmit={onNewsletterFormSubmit}
                        />
                    </div>
                    {!isNewsletterFormSubmitted && (
                        <p className="newsletter__text">
                            {newsletterData.text}
                        </p>
                    )}
                </div>
            </Container>
        </section>
    );
};

export default Newsletter;
